{
  "version": 1,
  "asset_id": "1178b359-ce0d-436c-a1b0-f01098bec882",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1178b359-ce0d-436c-a1b0-f01098bec882/sleeve-gastrectomy-es-v2-1536.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1178b359-ce0d-436c-a1b0-f01098bec882/sleeve-gastrectomy-es-v2-1536.webp",
  "original_filename": "sleeve-gastrectomy-es-v2-1536.webp",
  "size": 109622,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:35Z"
}
